import { TextMidd } from '@/components/ui/Text'
import css from './WorkspaceUsageItem.module.css'

interface WorkspaceUsageItemProps {
    label: string
    value: string
    percent?: number
    isFull?: boolean
}

const WorkspaceUsageItem = ({ label, value, percent, isFull }: WorkspaceUsageItemProps) => {
    return (
        <div className={css.container}>
            <div className={css.header}>
                <TextMidd><span className={css.label}>{label}</span></TextMidd>
                <TextMidd>{value}</TextMidd>
            </div>
            {percent !== undefined && (
                <div className={css.track}>
                    <div
                        className={[css.bar, isFull ? css.full : ''].filter(Boolean).join(' ')}
                        style={{ width: `${percent}%` }}
                    />
                </div>
            )}
        </div>
    )
}

export default WorkspaceUsageItem
